import * as ol from 'openlayers';

export class Polyline {
  private _layer: ol.layer.Vector = null;
  private _lineFeature: ol.Feature = null;
  private _source: ol.source.Vector = null;
  private _color: string;
  private _polylineWidth: number;
  private _map: ol.Map;
  private _pointArr: any = new Array();

  constructor(options: { color: string, width: number, pointArr: any }, map: ol.Map) {
    this._color = options.color;
    this._polylineWidth = options.width;
    this._pointArr = options.pointArr;
    this._map = map;
    this._createPolyline();
  }

  private _createPolyline(): void {
    this._source = new ol.source.Vector();
    this._layer = new ol.layer.Vector({
      source: this._source,
      style: new ol.style.Style({
        stroke: new ol.style.Stroke({
          color: this._color,
          width: this._polylineWidth
        })
      })
    });

    const line = new ol.geom.LineString(this._pointArr);
    this._lineFeature = new ol.Feature(line);
    this._layer.getSource().addFeatures([this._lineFeature]);
    this._map.addLayer(this._layer);
  }

  public setPolylineColor(color: string): void {
    const style: ol.style.Style = (<ol.style.Style>this._layer.getStyle());
    const stroke: ol.style.Stroke = style.getStroke() as ol.style.Stroke;
    stroke.setColor(color);
  }

  public getLayer(): ol.layer.Vector {
    return this._layer;
  }

  public setPolylineWidth(width: number): void {
    const style: ol.style.Style = this._layer.getStyle() as ol.style.Style;
    const stroke: ol.style.Stroke = style.getStroke() as ol.style.Stroke;
    stroke.setWidth(width);
  }

  public removePolyline(): void {
    this._map.removeLayer(this._layer);
    this._source.removeFeature(this._lineFeature);
    this._lineFeature = null;
    this._source = null;
    this._layer = null;
  }

}

export class AM {
  public xMax: number = 0;
  public xMin: number = 400;
  public yMax: number = 0;
  public yMin: number = 400;

  public getLngAndLatMaxMin(latlnt: { X: number, Y: number }): void {
    if (latlnt.X > this.xMax) {
      this.xMax = latlnt.X;
    }
    if (latlnt.Y > this.yMax) {
      this.yMax = latlnt.Y;
    }
    if (latlnt.X < this.xMin) {
      this.xMin = latlnt.X;
    }
    if (latlnt.Y < this.yMin) {
      this.yMin = latlnt.Y;
    }
  }

  public getLngLats(): Array<Array<number>> {
    const arr = [];
    arr.push([this.xMax], [this.yMax]);
    arr.push([this.xMin], [this.yMin]);
    return arr;
  }
}

export function getDeepColorNew(workstate, colors: Array<string> = ['blue', 'Lime']): string {
  if (workstate) {
    return colors[1];
  } else {
    return colors[0];
  }
}

export function getDeepColor(optrtdephts, workstate, standarddepth, colors: Array<string> = ['blue', 'red', 'Lime']): string {
  if (workstate) {
    if (optrtdephts >= standarddepth) {
      return colors[2];
    } else {
      return colors[1];
    }
  }
  return colors[0];
}


export function addPolylinePoint(workData, map: ol.Map, colors?: Array<string>): Array<Polyline> {
  let tPolyline: Polyline = null;
  const tPolylines: Array<Polyline> = [];
  const points = workData.gpsPoints;
  const isNJOpt = workData.isNJOpt;
  let index = -1;
  if (points.length > 1) {
    let arry = [];
    let curColor: string;
    if (index === -1) {
      index = 0;
      arry.push(points[0]);
      arry.push(points[1]);
      curColor = getDeepColorNew(isNJOpt[1], colors);
      index = 1;
    } else {
      arry.push(points[index]);
      curColor = getDeepColorNew(isNJOpt[index + 1], colors);
    }

    for (let i = index + 1; i < points.length; i++) {
      const color: string = getDeepColorNew(isNJOpt[i], colors);
      if (color === curColor) {
        arry.push(points[i]);
      } else {
        tPolyline = new Polyline({ color: curColor, width: 2, pointArr: arry }, map);
        tPolylines.push(tPolyline);
        arry = [];
        arry.push(points[i - 1]);
        arry.push(points[i]);
        curColor = color;
      }
    }
    if (arry.length > 0) {
      tPolyline = new Polyline({ color: curColor, width: 2, pointArr: arry }, map);
      tPolylines.push(tPolyline);
    }
    index = points.length - 1;
  }
  return tPolylines;
}


export function addPolylinePointAndDepth(workData, standarddepth: number, map: ol.Map, colors?: Array<string>): Array<Polyline> {
  let tPolyline: Polyline = null;
  const tPolylines: Array<Polyline> = [];
  const points = workData.gpsPoints;
  const optRtDepht = workData.optRtDephts;
  const isNJOpt = workData.isNJOpt;
  let index = -1;
  if (points.length > 1) {
    let arry = [];
    let curColor;
    if (index == -1) {
      index = 0;
      arry.push(points[0]);
      arry.push(points[1]);
      curColor = getDeepColor(optRtDepht[1], isNJOpt[1], standarddepth, colors);
      index = 1;
    } else {
      arry.push(points[index]);
      curColor = getDeepColor(optRtDepht[index + 1], isNJOpt[index + 1], standarddepth, colors);
    }
    for (let i = index + 1; i < points.length; i++) {
      const color = getDeepColor(optRtDepht[i], isNJOpt[i], standarddepth, colors);
      if (color == curColor) {
        arry.push(points[i]);
      } else {
        tPolyline = new Polyline({ color: curColor, width: 2, pointArr: arry }, map);
        tPolylines.push(tPolyline);
        arry = [];
        arry.push(points[i - 1]);
        arry.push(points[i]);
        curColor = color;
      }
    }
    if (arry.length > 0) {
      tPolyline = new Polyline({ color: curColor, width: 2, pointArr: arry }, map);
      tPolylines.push(tPolyline);
    }
    index = points.length - 1;
  }
  return tPolylines;
}
